var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    _vm._g(
      _vm._b(
        { attrs: { title: _vm.locale.prizeHistory, hasDecor: false } },
        "Dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.records.length
        ? [
            _c("h3", [_vm._v(_vm._s(_vm.locale.uid) + ": " + _vm._s(_vm.uid))]),
            _c("p", [_vm._v(_vm._s(_vm.locale.viaInGameMail))]),
            _c("div", { staticClass: "table" }, [
              _c("div", { staticClass: "thead" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _vm._v(_vm._s(_vm.locale.prizeName)),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _vm._v(_vm._s(_vm.locale.time)),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "tbody" },
                _vm._l(_vm.records, function (item, idx) {
                  return _c("div", { key: idx, staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _vm._v("amazon card $" + _vm._s(item.money)),
                    ]),
                    _c("div", { staticClass: "col" }, [
                      _vm._v(_vm._s(_vm._f("adFormatTime")(item.created_at))),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]
        : _c("p", { staticClass: "not-won" }, [
            _vm._v(_vm._s(_vm.locale.notWonAnyPrizes)),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }